import React from 'react';
import clsx from 'clsx';
import styles from './ProgressBar.module.css';

export interface ProgressBarProps {
  percentage: number | undefined;
  width?: string;
  showText?: boolean;
  emptyText?: string;
  className?: string;
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  percentage,
  width = 'var(--space-20)',
  showText = true,
  emptyText = 'Not started',
  className
}) => {
  if (percentage === undefined || percentage === null) {
    return (
      <div className={clsx(styles.progressInfo, className)}>
        <span className={styles.noProgress}>{emptyText}</span>
      </div>
    );
  }

  const clampedPercentage = Math.min(Math.max(percentage, 0), 100);

  return (
    <div className={clsx(styles.progressInfo, className)}>
      <div className={styles.progressBar} style={{ width }}>
        <div className={styles.progressFill} style={{ width: `${clampedPercentage}%` }} />
      </div>
      {showText && <span className={styles.progressText}>{clampedPercentage}%</span>}
    </div>
  );
};

export default ProgressBar;
